import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-map-modal',
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: './map-modal.component.html',
  styleUrls: ['./map-modal.component.scss']
})
export class MapModalComponent {
  selectedSeats = new Set<string>();
  hoveredSeat: string | null = null;

  // Seat configurationa
  seatSections = {
    NU: ['NU1', 'NU2', 'NU3', 'NU4', 'NU5'],
    NM: ['NM1', 'NM2', 'NM3', 'NM4', 'NM5'],
    NL: ['NL1', 'NL2', 'NL3', 'NL4', 'NL5'],
    EU: ['EU1', 'EU2', 'EU7', 'EU8'],
    EM: ['EM1', 'EM2', 'EM8'],
    EL: ['EL1', 'EL2', 'EL7', 'EL8'],
    SU: ['SU1', 'SU2', 'SU3', 'SU4', 'SU5'],
    SM: ['SM1', 'SM2', 'SM3', 'SM4', 'SM5'],
    SL: ['SL1', 'SL2', 'SL3', 'SL4', 'SL5'],
    WU: ['WU1', 'WU2', 'WU3', 'WU4', 'WU6', 'WU7', 'WU8'],
    WM: ['WM1', 'WM2', 'WM3', 'WM4', 'WM5', 'WM6', 'WM7', 'WM8'],
    WL: ['WL1', 'WL2', 'WL3', 'WL4', 'WL5', 'WL6', 'WL7', 'WL8'],
    D: Array.from({length: 24}, (_, i) => `D${i+1}`)
  };

  // Grouped seats for template iteration
  northTopSeats = ['D17', 'D18', 'D19', 'D20', 'D21', 'D22'];
  southBottomSeats = ['D10', 'D9', 'D8', 'D7', 'D6', 'D5'];
  
  eastSeatGroups = [
    ['D23', 'EU1'], ['D24', 'EU2'], 
    ['EM1', 'EM2'], ['EL1', 'EL2'], 
    ['EL7', 'EL8'], ['EM8', 'D3'], 
    ['EU7', 'D4'], ['EU8']
  ];

  westSeatGroups = [
    ['D16', 'WU8'], ['D15', 'WU7'], ['D14', 'WU6'],
    ['WM8', 'WM7'], ['WL8', 'WL7'], ['WL6', 'WL5'],
    ['WM6', 'WM5'], ['WU4', 'D2'], ['WM4', 'WL4'],
    ['WM3', 'WL3'], ['WU3', 'D1'], ['WM2', 'WL2'],
    ['WU2', 'WL1'], ['WU1', 'WM1'], ['D13', 'D12'],
    ['D11']
  ];

  constructor(
    public dialogRef: MatDialogRef<MapModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string, title?: string }
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  onSeatClick(seatId: string): void {
    this.selectedSeats.has(seatId) 
      ? this.selectedSeats.delete(seatId) 
      : this.selectedSeats.add(seatId);
  }

  onSeatHover(seatId: string): void {
    this.hoveredSeat = seatId;
  }

  onSeatLeave(): void {
    this.hoveredSeat = null;
  }

  getSeatClasses(seatId: string): string {
    const baseClasses = 'cursor-pointer transition-all duration-200 flex items-center justify-center text-xs font-medium border border-gray-300 rounded-sm w-8 h-8 hover:scale-105 ';
    
    if (this.selectedSeats.has(seatId)) {
      return baseClasses + 'bg-green-500 text-white shadow-md';
    } 
    if (this.hoveredSeat === seatId) {
      return baseClasses + 'bg-blue-400 text-white shadow-md';
    }
    if (seatId.startsWith('D')) {
      return baseClasses + 'bg-purple-600 text-white';
    }
    return baseClasses + 'bg-cyan-400 text-gray-800 hover:bg-cyan-300';
  }

  getSelectedSeatsArray(): string[] {
    return Array.from(this.selectedSeats);
  }

  getSelectedSeatsCount(): number {
    return this.selectedSeats.size;
  }
}